<script setup lang="ts">
import PdsBadge from '@/components/pds/PdsBadge.vue';
import PdsButton from '@/components/pds/PdsButton.vue';
import PdsIconButton from '@/components/pds/PdsIconButton.vue';
import PdsThemeSwitch from '@/components/pds/PdsThemeSwitch.vue';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import MenuPopover from '../components/MenuPopover.vue';
import PageBar from '../components/PageBar.vue';
import { usePdsOrdersStore } from '../stores/orders.store';

const store = usePdsOrdersStore();
const router = useRouter();
const menuOpen = ref(false);
</script>

<template>
  <PageBar>
    <h1 class="text-[24px] leading-[1.15] font-bold tracking-[-0.2px]">
      Commandes en retard
    </h1>
    <template #aside>
      <div class="hidden xl:block"><PdsThemeSwitch /></div>
      <PdsIconButton
        icon="search"
        label="Rechercher"
        :to="{ name: 'pds-search' }"
      />
      <PdsIconButton icon="menu" label="Menu" @click="menuOpen = true" />
    </template>
  </PageBar>

  <main
    class="no-scrollbar min-h-0 flex-1 overflow-y-auto px-4 pt-[18px] pb-4 sm:px-5 sm:pb-5"
  >
    <p
      v-if="!store.lateOrders.length"
      class="text-encre-douce text-[14px] leading-[1.4]"
    >
      Aucune commande en retard.
    </p>
    <div v-else class="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
      <article
        v-for="order in store.lateOrders"
        :key="order.id"
        class="bg-carte flex flex-col gap-[18px] rounded-[24px] py-6 pr-6 pl-5"
      >
        <header class="flex h-7 items-baseline gap-3">
          <p class="text-[24px] leading-[1.15] font-bold tracking-[-0.2px]">
            {{ store.lateMinutes(order) }} min
          </p>
          <p class="text-encre-douce text-[14px] leading-[1.4]">de retard</p>
          <p class="text-encre-douce text-[12px] leading-[1.45]">
            {{ order.items.length }}
            produit{{ order.items.length > 1 ? 's' : '' }}
          </p>
        </header>
        <div class="flex h-7 items-center gap-3">
          <p class="text-[18px] leading-[1.2] font-bold">#{{ order.number }}</p>
          <p
            class="text-encre-douce min-w-0 flex-1 truncate text-[14px] leading-[1.4]"
          >
            {{ order.label }}
          </p>
          <PdsBadge :tone="order.stage === 'new' ? 'new' : 'preparing'">
            {{ order.stage === 'new' ? 'Nouvelle' : 'En préparation' }}
          </PdsBadge>
        </div>
        <PdsButton
          variant="second"
          @click="router.push({ name: 'pds-order', params: { id: order.id } })"
        >
          Voir la commande
        </PdsButton>
      </article>
    </div>
  </main>

  <MenuPopover v-if="menuOpen" @close="menuOpen = false" />
</template>
